module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "profile"
  }, [_c('div', {
    staticClass: "tabs-content"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('h3', {
    staticClass: "heading",
    style: ({
      color: _vm.getCorpHeadingColor
    })
  }, [_c('br'), _vm._v(" "), _c('br'), _c('span', [_vm._v("Recently Watched Videos")])])]), _vm._v(" "), _c('div', {
    staticClass: "container-fluid"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "tabContent",
    class: {
      current: true
    },
    attrs: {
      "id": "tabs-1"
    }
  }, [_c('div', {}, [(_vm.getAuthRecentlyWatchedVideos) ? _c('div', {
    staticClass: "row yourFaves"
  }, [_c('div', {
    staticClass: "col-md-12"
  }), _vm._v(" "), _vm._l((_vm.getAuthRecentlyWatchedVideos), function(video) {
    return _c('div', {
      staticClass: "col-xs-12 col-sm-6 col-md-4 bottom-margin"
    }, [_c('a', {
      staticClass: "nounderline",
      attrs: {
        "href": '/watch/' + video.mediaid + '/' + video.title.replace(/[^a-zA-Z0-9]/g, '-').toLowerCase()
      }
    }, [_c('img', {
      staticClass: "jw-img",
      attrs: {
        "src": video.image,
        "title": video.title,
        "alt": video.title
      }
    }), _vm._v(" "), _c('p', {
      staticClass: "cursor"
    }, [_c('i', {
      staticClass: "fa fa-play-circle-o"
    }), _vm._v(" " + _vm._s(video.title))])]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('div', {
      staticClass: "plusicon btn-group"
    }, [_c('button', {
      staticClass: "dropdown-toggle ellipsis pull-right",
      attrs: {
        "title": "Add to Playlist",
        "id": video.mediaid,
        "type": "button"
      },
      on: {
        "click": function($event) {
          return _vm.showPlaylistMenu(video.mediaid)
        }
      }
    }, [_c('svg', {
      attrs: {
        "version": "1.1",
        "id": "Layer_1",
        "xmlns": "http://www.w3.org/2000/svg",
        "xmlns:xlink": "http://www.w3.org/1999/xlink",
        "x": "0px",
        "y": "0px",
        "width": "37px",
        "height": "24px",
        "viewBox": "0 0 37 24",
        "enable-background": "new 0 0 37 24",
        "xml:space": "preserve"
      }
    }, [_c('rect', {
      attrs: {
        "y": "0.2",
        "fill": _vm.getCorpHeaderColor,
        "width": "25",
        "height": "3"
      }
    }), _vm._v(" "), _c('rect', {
      attrs: {
        "y": "8.2",
        "fill": _vm.getCorpHeaderColor,
        "width": "25",
        "height": "3"
      }
    }), _vm._v(" "), _c('rect', {
      attrs: {
        "y": "17.2",
        "fill": _vm.getCorpHeaderColor,
        "width": "18.2",
        "height": "3"
      }
    }), _vm._v(" "), _c('rect', {
      attrs: {
        "x": "23",
        "y": "15.2",
        "fill": _vm.getCorpHeaderColor,
        "width": "14",
        "height": "4"
      }
    }), _vm._v(" "), _c('rect', {
      attrs: {
        "x": "27.958",
        "y": "10.242",
        "fill": _vm.getCorpHeaderColor,
        "width": "4",
        "height": "13.917"
      }
    })])]), _vm._v(" "), _c('ul', {
      staticClass: "hide"
    }, [(_vm.getUserPlaylists) ? _c('li', [_vm._m(0, true)]) : _vm._e(), _vm._v(" "), (_vm.getUserPlaylists) ? _c('li', {
      staticClass: "divider",
      attrs: {
        "role": "separator"
      }
    }) : _vm._e(), _vm._v(" "), _vm._l((_vm.getUserPlaylists), function(playlist) {
      return (_vm.getUserPlaylists) ? _c('li', [_c('label', {
        staticClass: "notificationwithcheckboxes"
      }, [_c('input', {
        attrs: {
          "type": "checkbox"
        },
        domProps: {
          "checked": _vm.verifyVideoExists(playlist, video)
        },
        on: {
          "click": function($event) {
            _vm.setPlaylistVideoStatus(video, playlist, _vm.verifyVideoExists(playlist, video))
          }
        }
      }), _vm._v(" " + _vm._s(playlist.title) + "\n                                                        "), _c('transition', {
        attrs: {
          "name": "fade"
        }
      }, [(video.mediaid === _vm.selectedVideo && playlist.playlistId === _vm.selectedPlaylist && _vm.videoAdded) ? _c('span', {
        staticClass: "added"
      }, [_vm._v("Added")]) : _vm._e()]), _vm._v(" "), _c('transition', {
        attrs: {
          "name": "fade"
        }
      }, [(video.mediaid === _vm.selectedVideo && playlist.playlistId === _vm.selectedPlaylist && _vm.videoRemoved) ? _c('span', {
        staticClass: "removed"
      }, [_vm._v("Removed")]) : _vm._e()])], 1)]) : _vm._e()
    }), _vm._v(" "), (_vm.getUserPlaylists) ? _c('li', {
      staticClass: "divider",
      attrs: {
        "role": "separator"
      }
    }) : _vm._e(), _vm._v(" "), _vm._m(1, true), _vm._v(" "), _c('li', [_c('label', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.newPlaylistName),
        expression: "newPlaylistName"
      }],
      staticClass: "form-control",
      attrs: {
        "type": "text"
      },
      domProps: {
        "value": (_vm.newPlaylistName)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.newPlaylistName = $event.target.value
        }
      }
    }), _vm._v(" "), _c('i', {
      staticClass: "fa fa-plus-circle",
      attrs: {
        "title": "Insert New Playlist"
      },
      on: {
        "click": _vm.addNewPlayList
      }
    })])])], 2), _vm._v(" "), _c('div', {
      staticClass: "backdropformenu",
      on: {
        "click": function($event) {
          return _vm.hidePlaylistMenu(video.mediaid)
        }
      }
    })]), _vm._v(" "), _c('p', {
      staticClass: "right-heart-icon"
    }, [_c('a', {
      attrs: {
        "href": "javascript:",
        "title": "Liked this video?"
      },
      on: {
        "click": function($event) {
          return _vm.setVideoStatus(video)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-2x fa-heart-o",
      class: {
        'activeIcons': _vm.getVideoStatus(video)
      },
      style: ({
        color: _vm.getCorpHeaderColor
      }),
      attrs: {
        "aria-hidden": "true"
      }
    })])])])
  })], 2) : _vm._e()])])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', [_c('b', [_vm._v(" Add to ...")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('label', {
    staticStyle: {
      "color": "#f0617d"
    }
  }, [_vm._v("Create new playlist")])])
}]}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-65ebedb2", module.exports)
  }
}


// WEBPACK FOOTER //
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-65ebedb2"}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/string-replace-loader?{"search":"pk_test_6pRNASCoBOKtIshFeQd4XMUh","replace":"pk_test_SLHUyTkZmNS1OnLNdclgNldo"}!./~/string-replace-loader?{"search":"https:/www1.dev-tonenetworks.com","replace":"https:/www1.dev-tonenetworks.com"}!./~/string-replace-loader?{"search":"https:/s3.amazonaws.com/tone-assets/app/navigation","replace":"https:/s3.amazonaws.com/tone-assets/app/navigation"}!./~/string-replace-loader?{"search":"sandbox_2yn8x45w_k2v4j3d55x4gh6xz","replace":"production_6r7mxqgh_htw3nq9wp32w8h2x"}!./src/components/RecentlyWatched.vue